import { motion } from "framer-motion";
import imageDimensions from "../lib/image-dimensions.json";

export const easeOut = [0.22, 1, 0.36, 1];

const isPrerenderHydration = () =>
  typeof window !== "undefined" && window.__NOOR_PRERENDERED__ === true;

const responsiveSrcSet = (src) => {
  if (!src?.startsWith("/api/uploads/") || src.includes("--w")) return undefined;
  return [480, 768, 1200, 1600]
    .map((w) => `${src.replace(/\.webp$/, `--w${w}.webp`)} ${w}w`)
    .join(", ");
};

export function Reveal({ children, delay = 0, className = "", y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={isPrerenderHydration() ? false : { opacity: 0, y, scale: 0.985 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: easeOut }}
      style={{ transformOrigin: "center bottom" }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={isPrerenderHydration() ? false : { y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1, delay, ease: easeOut }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Overline({ children, light = false, className = "" }) {
  return (
    <p
      className={`font-mono text-xs tracking-[0.3em] uppercase ${
        light ? "text-ember" : "text-ember"
      } ${className}`}
    >
      {children}
    </p>
  );
}

export function FrameReveal({ src, alt, className = "", hoverZoom = true, eager = false, testid }) {
  const dimensions = imageDimensions[src] || {};
  return (
    <motion.div
      className={`overflow-hidden ${className}`}
      initial={isPrerenderHydration() ? false : { clipPath: "inset(14% 0% 14% 0%)", opacity: 0 }}
      whileInView={{ clipPath: "inset(0% 0% 0% 0%)", opacity: 1 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 1.1, ease: easeOut }}
    >
      <motion.img
        src={src}
        srcSet={responsiveSrcSet(src)}
        sizes="(max-width: 768px) 100vw, 1200px"
        width={dimensions.width}
        height={dimensions.height}
        alt={alt}
        data-testid={testid}
        initial={isPrerenderHydration() ? false : { scale: 1.14, y: "4%" }}
        whileInView={{ scale: 1, y: 0 }}
        whileHover={hoverZoom ? { scale: 1.045, transition: { duration: 0.6, ease: easeOut } } : undefined}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1.5, ease: easeOut }}
        className="w-full h-full object-cover will-change-transform"
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
        draggable={false}
      />
    </motion.div>
  );
}
